/*! Journey timeline (sections/journey-timeline.liquid): scroll-driven progress line, replicating the source
 *  ("Sugar" timeline, activation-mode=scroll, line-end=stop):
 *  - the line container ends at the last circle's center;
 *  - active height = clamp((viewportCenter - lineTop) / lineHeight, 0, 1), updated on scroll (rAF) and resize;
 *  - a milestone is active while the painted line reaches its circle center (+5px) and reverts on scroll-up;
 *  - at the page bottom an unreached tail completes.
 */
(function () {
  'use strict';
  if (customElements.get('journey-timeline')) return;
  class JourneyTimeline extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-timeline-track]');
      this.lineContainer = this.querySelector('[data-timeline-line]');
      this.activeLine = this.querySelector('[data-timeline-active-line]');
      if (!this.track || !this.lineContainer || !this.activeLine) return;
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => { this.update(); this.ticking = false; });
      };
      this.onResize = () => { this.measureEnd(); this.update(); };
      this.measureEnd();
      this.update();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      window.addEventListener('load', this.onResize);
      if (typeof ResizeObserver !== 'undefined') {
        this.ro = new ResizeObserver(() => this.onResize());
        this.ro.observe(this.track);
      }
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('load', this.onResize);
      if (this.ro) this.ro.disconnect();
    }
    circles() { return Array.prototype.slice.call(this.track.querySelectorAll('[data-timeline-circle]')); }
    measureEnd() {
      const list = this.circles();
      const last = list[list.length - 1];
      if (!last) return;
      const trackRect = this.track.getBoundingClientRect();
      const r = last.getBoundingClientRect();
      const bottom = trackRect.bottom - (r.top + r.height / 2);
      this.lineContainer.style.bottom = Math.max(0, Math.round(bottom)) + 'px';
    }
    update() {
      const lineRect = this.lineContainer.getBoundingClientRect();
      const trackRect = this.track.getBoundingClientRect();
      const viewportCenter = window.innerHeight / 2;
      if (lineRect.height === 0) return;
      let p = (viewportCenter - lineRect.top) / lineRect.height;
      p = Math.max(0, Math.min(1, p));
      const doc = document.documentElement;
      const pageHeight = Math.max(doc.scrollHeight || 0, document.body ? document.body.scrollHeight : 0);
      const atBottom = window.scrollY + window.innerHeight >= pageHeight - 2;
      if (atBottom && trackRect.top < window.innerHeight && trackRect.bottom > 0 && lineRect.bottom > viewportCenter) p = 1;
      this.activeLine.style.height = (p * 100) + '%';
      const painted = lineRect.top + lineRect.height * p;
      const milestones = this.track.querySelectorAll('[data-timeline-milestone]');
      for (let i = 0; i < milestones.length; i++) {
        const circle = milestones[i].querySelector('[data-timeline-circle]');
        const r = (circle || milestones[i]).getBoundingClientRect();
        milestones[i].classList.toggle('is-active', r.top + r.height / 2 <= painted + 5);
      }
    }
  }
  customElements.define('journey-timeline', JourneyTimeline);
})();
